import { render, staticRenderFns } from "./NotificationPermissions.vue?vue&type=template&id=03b56ce3&scoped=true"
import script from "./NotificationPermissions.vue?vue&type=script&lang=js"
export * from "./NotificationPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b56ce3",
  null
  
)

export default component.exports